import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { of } from 'rxjs';
import { AccountService } from '../services/account/account.service';

export const externalGuard: CanActivateFn = (route, segments) => {
  const account = inject(AccountService);
  return of(!account.isInternal);
};
